import axios from "axios";
import authHeader from "@/services/auth-header";

class StatusService {
  get(fileDataId) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/Status/${fileDataId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  update(status, fileDataId) {
    return axios
      .put(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/Status/WithoutLoanStatus/${fileDataId}`,
        status,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }
  updateStatusOnly(status, fileDataId) {
    return axios
      .put(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/Status/OnlyLoanStatus/${fileDataId}`,
        status,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }
}

export default new StatusService();
